import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-footer-page',
  templateUrl: './header-footer-page.component.html',
  styleUrls: ['./header-footer-page.component.scss']
})
export class HeaderFooterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
